module.exports = __webpack_public_path__ + "static/media/03.d8882219.webp";